import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBremen() {
  return (
    <CityPageTemplate
      city="Bremen"
      slug="bremen"
      intro="In der Hansestadt Bremen beraten wir Dich digital und unabhängig – ganz ohne Banktermin."
      description="Unabhängige Finanzberatung für Bremen – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
